import {
  Page,
  Card,
  Layout,
  IndexTable,
  Thumbnail,
  TextField,
  BlockStack,
  Box,
  Link,
  Button,
  InlineStack,
  Text,
  EmptyState,
  SkeletonPage,
  SkeletonBodyText,
  Toast,
  useIndexResourceState,
} from "@shopify/polaris";
import 'react-zmage/style.css';
import React, { useEffect, useState } from 'react';
import './index.css';
import intl from '../../../i18n/intl';

import utils from '../../../utils/utils';
import { useHistory, withRouter } from "react-router-dom";
import { reqGetPersonInventoryOrderListVariants, reqGetPersonInventoryOrderPurchase} from "../../../api";

const Index = ()=> {
  const router = useHistory();
  const [initPageData,setInitPageData] = useState({
    isInit:true,
    pageLoading:false
  })
 
  const [purchasePageData,setPurchaseData] = useState({});

  const getPurchasePage = async ()=>{
    let url = new URLSearchParams(window.location.search);
    let record_id = url.get("record_id")
    let params = {
      product_id:record_id
    }
    try {
      let res = await reqGetPersonInventoryOrderListVariants(params);
      if (res.code === '200') {
        let list = res.data.variants.map((item)=>{
          return {...item,quantity:50}
        });
        let data = {...res.data,variants:list}
        setPurchaseData(data);
      }
      setInitPageData({
        isInit:false,
        pageLoading:false
      })
    } catch (error) {
      
    }
    
  }
  useEffect(() => {
    let isMount = false;
    if (!isMount) {
      getPurchasePage()
    }
    return () => {
      isMount = true;
    };
  }, []);


  // 总数量
  const quantityFun = (data)=>{
    let num = 0;
    let variants =[];
    if (data) {
      data.forEach((item)=>{
        if (selectedResources.includes(item.id)) {
          variants.push(item)
        } 
      })
    }
    if (variants.length > 0) {
      variants.forEach((item)=>{
        num += Number(item.quantity)
      })
    }
    
    return num;
  }

  // 总金额
  const totalPriceFun = (data)=>{
    let num = 0;
    let variants =[];
    if (data) {
      data.forEach((item)=>{
        if (selectedResources.includes(item.id)) {
          variants.push(item)
        } 
      })
    }
    if (variants.length > 0) {
      variants.forEach((item)=>{
        num += Number(item.before_convert_cost) * Number(item.quantity)
    })
    }
    
    return num.toFixed(2);
  }


  const [showToast, setShowToast] = useState(false);
  const [showToastText, setShowToastText] = useState("");
  const [showToastIserror, setShowToastIserror] = useState(false);
  //提示弹窗
  const toggleToast = (showToastText, showToastIserror = false) => {
    setShowToast(showToastText !== "");
    setShowToastText(showToastText);
    setShowToastIserror(showToastIserror);
  };
  const toastMarkup = showToast ? (
    <Toast
      content={showToastText}
      onDismiss={() => toggleToast("")}
      error={showToastIserror}
      duration={2000}
    />
  ) : null;

  const {selectedResources, allResourcesSelected, handleSelectionChange} =
  useIndexResourceState(purchasePageData?.variants);
  // 页面更新

  // 修改库存数量
  const onChangeQuantity = (value, recordKey) => {
    let data = purchasePageData.variants;
    let num = Number(value);
    data[recordKey].quantity = num;
    setPurchaseData((prevValue)=>({
      ...prevValue,
      variants:data
    }))
  }
  const onChangeBulrQuantity = (value, recordKey) => {
    let data = purchasePageData.variants;
    let num = Number(value);
    if (num < 50) {
      num = Number(50)
    }
    if (num > 99999) {
      num = 99999;
    }
    data[recordKey].quantity = num;
    setPurchaseData((prevValue)=>({
      ...prevValue,
      variants:data
    }))
  }

  // 创建订单
  const handleCreateOrder = async () => {
    let list = purchasePageData.variants;
   let variants = [];
   if (list) {
    list.forEach((item)=>{
      if (selectedResources.includes(item.id)) {
        variants.push({
          vid:item.id,
          quantity:item.quantity
        })
      }
     })
   }
   


    let params = {
      product_id: purchasePageData.product.id,
      list: variants,
    }
    let res = await reqGetPersonInventoryOrderPurchase(params);
    if (res.code === "200") {
      // utils.routeListen('/admin/customService/inventory')
      utils.routeJump1(router,'/admin/customService/inventory?selected=1')
    }
  }
 
  const EmptyProductList = (
    <div className="emptyWithImg">
       <EmptyState
        heading={intl.get("Sorry, no results found.")}
        image="/empty.svg"
      >
      </EmptyState>
    </div>
  );
  

  const skeletonPage =  <SkeletonPage fullWidth={false}>
  <Layout>
   <Layout.Section>
   <Card>
   <BlockStack gap={400}>
   <SkeletonBodyText lines={3}/>
   <SkeletonBodyText lines={3}/>
   <SkeletonBodyText lines={3}/>
   <SkeletonBodyText lines={3}/>
   <SkeletonBodyText lines={3}/>
   <SkeletonBodyText lines={3}/>
   <SkeletonBodyText lines={3}/>
   <SkeletonBodyText lines={3}/>
   <SkeletonBodyText lines={3}/>
   </BlockStack>
   </Card>
 </Layout.Section>
   </Layout>
 </SkeletonPage>
    // 列表数据
    const rowMarkup = Object.values(purchasePageData).length > 0 && (purchasePageData?.variants.map((item, index) => {
      let imageUrl = '/default_image.png';
      if (item.image_url !== '' && (typeof item.image_url) !== 'object') {
        imageUrl = item.image_url;
      }
     
      return (
        <IndexTable.Row
          id={item.id}
          key={item.id}
          selected={selectedResources.includes(item.id)}
          position={index}
        >
          <IndexTable.Cell>
          <Link
            dataPrimaryLink
            url={''}
            onClick={() => console.log()}
          >
            <Thumbnail source={imageUrl} alt={purchasePageData.title} />
          </Link>
         
          </IndexTable.Cell>
          <IndexTable.Cell>
            <div className="Inventory_Product">
              <div className="Inventory_Product__Title shopping_cart" title={purchasePageData.title}><span>{purchasePageData.title}</span></div>
              <div className="Inventory_Variant_Title">{item.option_one}</div>
              <div>{item.option_two}</div>
              <div>{item.option_three}</div>
            </div>
          </IndexTable.Cell>
          <IndexTable.Cell>
            <div>{'$' + Number(item.before_convert_cost).toFixed(2) + ' USD'}</div>
          </IndexTable.Cell>

          <IndexTable.Cell>
            <div>
              <BlockStack>
                <span>{'$' + (Number(item.before_convert_cost) * Number(item.quantity)).toFixed(2) + ' USD  *'}</span>
                <TextField
                  type='number'
                  onChange={(value) => {onChangeQuantity(value,index)}}
                  onBlur={(e) => {onChangeBulrQuantity(e.target.value, index)}}
                  value={String(item.quantity)}
                  min={item.min_quantity}
                />
              </BlockStack>
            </div>
          </IndexTable.Cell>
        </IndexTable.Row>
      );
    },
    ));
   
    const resourceName = {
      singular: 'id',
      plural: 'orders',
    };
    
    const pageConteent = initPageData.isInit ? skeletonPage : (  <Page
      backAction={
        false ? undefined : {
        content:'',
        onAction: () => {
          // utils.routeListen('/admin/customService/inventory')
          utils.routeJump1(router,'/admin/customService/inventory')
        }
      }}
      title={<div style={{fontSize:20}}>{intl.get('Purchase')}</div>}
    >
      <Layout>
        <Layout.Section>
          <BlockStack gap={400}>
          
        <Box>
          <Card>
        {Object.values(purchasePageData).length > 0 ? <Box style={{maxHeight:'380px',overflowY:'auto',overflowX:'hidden'}}>
            <IndexTable
                  resourceName={resourceName}
                  itemCount={purchasePageData?.variants.length}
                  selectedItemsCount={
                    allResourcesSelected ? 'All' : selectedResources.length
                  }
                  onSelectionChange={handleSelectionChange}
                  headings={[
                    { title: '' },
                    { title: 'Sku' },
                    { title: 'Price' },
                    { title: 'Quantity' },
                  ]}
                >
                {rowMarkup}
                  
                </IndexTable>
            </Box>:EmptyProductList}
            </Card>
        </Box>
        <Box>
        <Card>
           <Text variant="headingMd" as="h2">{intl.get("Order")}</Text>
           <BlockStack>
              <InlineStack align='space-between'>
              <Box>
                <Text variant="headingMd" as="h2">{intl.get("Quantity")}:</Text>
              </Box>
              <Box>
                <div className='prepaid_order_total'>{quantityFun(purchasePageData?.variants)}</div>
              </Box>
              </InlineStack>
            </BlockStack>
            <BlockStack>
              <InlineStack align='space-between'>
              <Box>
                <Text variant="headingMd" as="h2">{intl.get("Subtotal")}:</Text>
              </Box>
              <Box>
                <div className='prepaid_order_total'>{'$ ' + totalPriceFun(purchasePageData?.variants) + ' USD'}</div>
              </Box>
              </InlineStack>
              <Box style={{ marginTop: '10px' }}>
              <InlineStack align='end'>
              <Button variant='primary' disabled={selectedResources.length === 0} onClick={()=>{handleCreateOrder()}}>{intl.get('Continue')}</Button>
              </InlineStack>
              </Box>
            </BlockStack>
          </Card>
        </Box>
        </BlockStack>
        </Layout.Section>
        </Layout>
        </Page>
    )
    return (
        <div className='purchase_list'>
         {pageConteent}
         {toastMarkup}
        </div>
    );
}


export default withRouter(Index);
